import React from 'react';
import { Button, Paper, Stack, Typography } from '@mui/material';

interface TradeSessionPanelProps {
  locationState: any;
  submitting: boolean;
  onLocationCheckIn: () => void;
  onConfirmCompletion: () => void;
  onReportIssue: () => void;
}

const TradeSessionPanel: React.FC<TradeSessionPanelProps> = ({
  locationState,
  submitting,
  onLocationCheckIn,
  onConfirmCompletion,
  onReportIssue,
}) => {
  return (
    <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
      <Stack spacing={1.5}>
        <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
          Go to {locationState?.location?.name || 'your assigned trade location'}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Participants at location: {locationState?.checkedInCount || 0} of {locationState?.totalParticipants || 0}
        </Typography>
        <Button variant="outlined" onClick={onLocationCheckIn} disabled={submitting || Boolean(locationState?.selfState?.locationCheckedInAt)}>
          {locationState?.selfState?.locationCheckedInAt ? 'You are checked in at the location' : 'I am at this trade location'}
        </Button>
        {locationState?.session?.status === 'active' && (
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5}>
            <Button variant="contained" onClick={onConfirmCompletion} disabled={submitting || Boolean(locationState?.selfState?.completionConfirmedAt)}>
              {locationState?.selfState?.completionConfirmedAt ? 'You confirmed receipt' : "I've inspected and received my item(s)"}
            </Button>
            <Button variant="outlined" color="warning" onClick={onReportIssue} disabled={submitting || Boolean(locationState?.selfState?.issueReportedAt)}>
              {locationState?.selfState?.issueReportedAt ? 'Issue reported' : 'Report Issue'}
            </Button>
          </Stack>
        )}
      </Stack>
    </Paper>
  );
};

export default TradeSessionPanel;
